import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '@kcftech/design-system';
import { IPictureFileMetadataResponse } from '@kcftech/prometheus-client';
import { AuthorizedImage } from 'components/media/AuthorizedImage';
import { CellNameText, dirEntryThumbnailCss } from 'pages/Settings/FileLibrary/styled';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

import { createFileLibraryDirentNavPath, DirentIdentityInfo } from '../path';
import { FilesLinkCell } from './styled';

const Thumbnail = styled(AuthorizedImage)`
    ${dirEntryThumbnailCss}
`;

export type FileData = Pick<
    IPictureFileMetadataResponse,
    'Id' | 'DisplayName' | 'FileName' | 'ThumbnailFileName'
> & {
    LocationId: string | undefined;
};

export type ImageFileNameCellProps = Readonly<{
    fileData: {
        name: string;
        thumbnailStorageKey: string | undefined;
        mediaType: string | undefined;
    } & DirentIdentityInfo;
    enableModal: boolean;
    prefetch?: () => void;
}>;

export function ImageFileNameCell({
    fileData,
    enableModal,
    prefetch,
}: ImageFileNameCellProps) {
    return (
        <FilesLinkCell
            to={createFileLibraryDirentNavPath(fileData, 'file')}
            target={enableModal ? '_blank' : ''}
            rel={enableModal ? 'noreferrer noopener' : ''}
            iconColor={tokens.icon.actionActive}
            onPointerEnter={prefetch}
        >
            <Thumbnail
                storageKey={fileData.thumbnailStorageKey}
                mediaType={fileData.mediaType}
                aria-label={`Thumbnail for ${fileData.name}`}
                alt={`Thumbnail for ${fileData.name}`}
                pending={<Spinner className="pr-15" />}
                imageScaling="contain"
                fallback={
                    <FontAwesomeIcon
                        icon={faImage}
                        color={tokens.icon.actionActive}
                        title="Image"
                        aria-label="Image"
                        size="3x"
                    />
                }
            />
            <CellNameText className="ellipsis-1-line" title={fileData.name}>
                {fileData.name}
            </CellNameText>
        </FilesLinkCell>
    );
}
